import { css, styled } from 'styled-components'

export const baseHeading = css`
	font-family: ${({ theme }) => theme.fonts.heading};
	font-weight: 700;
	scroll-margin-top: 1rem; /* Add a margin for anchor links */
	color: ${({ theme }) =>
		theme.darkMode
			? theme.colors.extended.grey[100]
			: theme.colors.bases.primary[700]};
	background-color: transparent;
`

export const HeadingUnderline = css`
	&::after {
		height: 1.25rem;
		width: 5rem;
		display: block;
		content: ' ';
		border-bottom: 4px solid ${({ theme }) => theme.colors.bases.secondary[500]};
	}
`

export const H1Style = css`
	${baseHeading}
	${HeadingUnderline}
	font-size: ${({ theme }) => theme.fontSizes.xxxl};
	margin: ${({ theme }) => css`
		${theme.spacings.xxxl} 0 ${theme.spacings.xl}
	`};
	line-height: 2.375rem;

	@media print {
		margin: ${({ theme }) => theme.spacings.xl} 0;
	}
`
export const H1 = styled.h1`
	${H1Style}
`

export const H2Style = css`
	${baseHeading}
	${HeadingUnderline}
	font-size: 1.625rem;
	line-height: ${({ theme }) => theme.lineHeights.lg};
	margin: ${({ theme }) => css`
		${theme.spacings.xxl} 0 ${theme.spacings.lg}
	`};

	@media print {
		margin: ${({ theme }) => theme.spacings.xl} 0;
	}
`
export const H2 = styled.h2`
	${H2Style}
`

export const H3Style = css`
	${baseHeading}
	margin: ${({ theme }) => css`
		${theme.spacings.xl} 0 ${theme.spacings.md}
	`};
	font-size: ${({ theme }) => theme.fontSizes.xl};
	line-height: ${({ theme }) => theme.lineHeights.lg};
`
export const H3 = styled.h3`
	${H3Style}
`

export const H4Style = css`
	${baseHeading}
	margin: ${({ theme }) => css`
		${theme.spacings.lg} 0 ${theme.spacings.sm}
	`};
	font-size: ${({ theme }) => theme.fontSizes.lg};
	line-height: ${({ theme }) => theme.lineHeights.base};
`
export const H4 = styled.h4`
	${H4Style}
`

export const H5Style = css`
	${baseHeading}
	font-size: ${({ theme }) => theme.fontSizes.base};
	margin: ${({ theme }) => css`
		${theme.spacings.md} 0 ${theme.spacings.xs}
	`};
	line-height: ${({ theme }) => theme.lineHeights.base};
`
export const H5 = styled.h5`
	${H5Style}
`

export const H6 = styled.h6`
	${baseHeading}
	margin: ${({ theme }) => css`
		${theme.spacings.sm} 0 ${theme.spacings.xxs}
	`};
	font-size: ${({ theme }) => theme.fontSizes.base};
	line-height: ${({ theme }) => theme.lineHeights.base};
`
